import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TbScrollSingleActive } from './tb-scroll-single-active.directive';

@NgModule({
  declarations: [TbScrollSingleActive],
  imports: [
    CommonModule
  ],
  exports:[TbScrollSingleActive]
})
export class TbScrollSingleActiveModule { }
